/*
该文件是整个项目的入口文件
*/
//引入vue
import Vue from 'vue'
import router from './router'
import ElementUi from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"
import { Notify } from 'vant';
import axios from "axios"
import store from './store'
//引入App组件，它是所有组件的父组件
import App from './App.vue'
import Print from './utils/print'
//关闭vue生产提示
Vue.config.productionTip = false
Vue.use(ElementUi)
Vue.use(Notify)
Vue.use(Print)
Vue.prototype.$axios = axios
axios.defaults.baseURL = "/pre"
Vue.prototype.$eventBus = new Vue()

//请求拦截
axios.interceptors.request.use(config => {
  if (store.state.token){
    config.headers['Authorization'] = store.state.token;
  }
  return config;
}, error => {
  console.log(error);
})

//数组做差
Array.prototype.diff = function (a) {
  return this.filter(function (i) {return a.indexOf(i) < 0;});
};

Vue.prototype.transDateFormat = function (fmt) {  //转换date类型为yyyy-MM-dd
  let date = new Date(fmt);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  return year + "-" + month + "-" + day;
}

Vue.prototype.transDateFormatToTime = function(fmt) {
  let date = new Date(fmt)
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  let hh = date.getHours < 10 ? '0' + date.getHours() : date.getHours();
  let mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hh + ":" + mm + ':' + ss
}

// Vue.prototype.setOcc = function(){
//   this.$axios.get()
// }

Vue.prototype.getNowFormatDate = function () {  //获取系统当前时间
  // let now = new Date();
  // let year = now.getFullYear();
  // let month = now.getMonth() + 1;
  // let d = now.getDate();
  // let hour = now.getHours();
  // let minute = now.getMinutes();
  // let second = now.getSeconds();
  // let milliseconds = now.getMilliseconds();
  // if (hour < 10) {
  //   hour = "0" + hour;
  // }
  // if (minute < 10) {
  //   minute = "0" + minute;
  // }
  // if (second < 10) {
  //   second = "0" + second;
  // }
  // if (milliseconds < 10) {
  //   milliseconds = "00" + milliseconds;
  // }
  // else if (milliseconds < 100) {
  //   milliseconds = "0" + milliseconds;
  // }
  // if (month < 10) {
  //   month = "0" + month;
  // }
  // if (d < 10) {
  //   d = "0" + d;
  // }
  // return year + "-" + month + "-" + d + " " + hour + ":" + minute + ":" + second + "." + milliseconds;
  return Date.now();
}

async function getTerminalType() {
  if (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)) {
    return 'mobile';
  }
  else {
    return 'pc';
  }
}

router.beforeEach(async (to, from, next) => {
  let terminalType = await getTerminalType();
  if (terminalType === 'mobile' && to.name.indexOf('/mobile') !== -1) {
    if (to.meta.requireAuth) {
      if (window.localStorage.getItem("token") !== null) {
        next();
      }
      else if (window.localStorage.getItem("vuex")) {
        if (Object.values(JSON.parse(window.localStorage.getItem("vuex")))[0]) {
          next();
        }
      }
      else {
        next({
          path: '/'
        })
        Notify({ type: 'danger', message: '请先登录账号！' });
      }
    }
    else {
      next();
    }
  }
  else if (terminalType === 'pc' && to.name.indexOf('/pc') !== -1) {
    if (to.meta.requireAuth) {
      if (window.localStorage.getItem("token") !== null) {
        next();
      }
      else if (window.localStorage.getItem("vuex")) {
        if (Object.values(JSON.parse(window.localStorage.getItem("vuex")))[0]) {
          next();
        }
      }
      else {
        next({
          path: '/'
        })
        ElementUi.Message.error("请先登录账号！");
      }
    }
    else {
      next();
    }
  }
  else {
    next(false);
  }
})

//创建vue实例对象
new Vue({
  router,
  store,
  //将App组件放入容器中
  render: h => h(App)
}).$mount('#app')


